import AuthScreenShell from './AuthScreenShell';

export default AuthScreenShell;
